import React, { Component } from "react";
import TitleBar from "../_common/TitleBar";
import visionScreen from "../../img/vision.png";
import weatScreen from "../../img/weat.jpg";

class LinkContainer extends Component {
  state = {};
  getContent = () => {
    switch (this.props.content) {
      case "/vision":
        return visionScreen;
      case "/weat":
        return weatScreen;
      default:
        return;
    }
  };
  render() {
    return (
      <React.Fragment>
        <TitleBar titleText="Link" />
        <div className="card mx-4">
          <div className="card-body">
            <img
              src={this.getContent()}
              alt="Link Preview"
              width="1200"
              height="900"
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default LinkContainer;
